<template>
  <div v-if="!isResultLoaded" class="search_results search_results--preview">
    <spinner :containerClass="`width--50px min-height--150px`" />
  </div>
  <div v-else-if="totalResults > 0" class="search_results search_results--preview">
    <div class="card mb-4">
      <div class="card-body pt-3 pb-0">
        <router-link :to="{ name: `${route.name}.explore`, params: { category: index }}" class="t-sm pull-right t-400">
          view all
        </router-link>
        <h3 class="t-md t-500 mb-2">Web Pages</h3>
        <div v-for="(result, index) in results" :key="index">
          <div class="mb-1" v-html="getResultBody(result)" v-line-clamp="3" />
          <div class="mb-4">
            <i class="fa fa-link t-secondary mr-2" /><a :href="result.data.url" target="_blank">{{ result.data.url.split('?')[0] }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchService from '@/services/search'
import searchHelpers from '@/mixins/search/helpers'

import Spinner from '@/components/shared/Spinner'

export default {
  name: 'webpagesContainerPreview',
  mixins: [searchHelpers],
  components: {
    Spinner
  },
  props: {
    route: {
      type: Object,
      required: true
    },
    searchFilterObject: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    totalDocuments: {
      type: Number,
      required: false,
      default: 5
    },
    scope: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isResultLoaded: false,
      results: {},
      totalResults: 0
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    getResultBody (result) {
      let output = ''
      // Add exact/match label
      if (result.hit_type) output = `<span class="t-xs t-yellow px-1 py-1 mr-1 bg-grey bd-radius t-uppercase">${this.$options.filters.humanize(result.hit_type)}</span>`
      if (result.highlights && !this.isEmpty(result.highlights.body)) return `${output}${result.highlights.body[0]}`
      return result.data.body
    },
    fetch () {
      if (!this.globalSearchKeyword) {
        this.isResultLoaded = true
        this.totalResults = 0
        return
      }
      const searchObject = this.getSearchObjectPreview(this.searchFilterObject, [this.index], this.totalDocuments, [])

      SearchService.searchTopMatches(searchObject).then(results => {
        this.totalResults = results.categories[this.index].total

        this.results = results.categories[this.index].results
        this.isResultLoaded = true
      }).catch(err => {
        this.isResultLoaded = !this.isEmpty(err)
        this.error = this.handleError(err)
      })
    }
  }
}
</script>
